<template>
  <div class="vip-page common-bg">
    <!-- 顶部VIP卡片 -->
    <div class="vip-card">
      <div class="vip-card-bg">
        <img src="/static/image/vip/img_vip_card_bg.avif" class="vip-card-bg-img" />
      </div>
      <div class="vip-card-content">
        <div class="vip-card-left">
          <div class="vip-current-label">当前等级</div>
          <div class="vip-level-row">
            <span class="vip-level-text">VIP {{ currentLevel }}</span>
            <div class="vip-upgrade-btn" @click="handleUpgrade">去升级 &gt;</div>
          </div>
          <div class="vip-progress-row">
            <span class="vip-progress-pct">{{ progressPercent }}%</span>
            <div class="vip-progress-bar">
              <div class="vip-progress-fill" :style="{ width: progressPercent + '%' }"></div>
              <div class="vip-progress-thumb" :style="{ left: progressPercent + '%' }"></div>
            </div>
            <span class="vip-level-next">VIP {{ currentLevel + 1 }}</span>
          </div>
          <div class="vip-tip-text">只需投注{{ formatNumber(nextLevelAmount) }}即可享受会员权益</div>
        </div>
        <div class="vip-card-right">
          <div class="vip-icon-wrap">
            <div class="vip-icon-bg"></div>
            <img src="/static/image/vip/style_4_vip_style0.avif" class="vip-card-icon" />
            <span class="vip-icon-badge-num">{{ currentLevel }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- VIP奖励列表标题 -->
    <div class="vip-list-title">
      <svg class="title-deco title-deco-left" viewBox="0 0 30 50" fill="none">
        <!-- 主枝干 -->
        <path d="M22 48C18 40 12 30 8 18C6 12 6 6 8 2" stroke="#bbb" stroke-width="1.2" fill="none" opacity="0.8"/>
        <!-- 左侧叶子 -->
        <path d="M14 36C10 34 6 34 4 36C6 34 10 32 14 34Z" fill="#aaa" opacity="0.8"/>
        <path d="M10 28C6 26 3 26 1 28C3 26 6 24 10 26Z" fill="#aaa" opacity="0.8"/>
        <path d="M8 20C5 18 2 18 0 20C2 18 5 16 8 18Z" fill="#aaa" opacity="0.8"/>
        <path d="M9 12C6 10 4 10 2 12C4 10 6 8 9 10Z" fill="#aaa" opacity="0.8"/>
        <path d="M12 6C10 4 8 4 6 6C8 4 10 3 12 5Z" fill="#aaa" opacity="0.8"/>
        <!-- 右侧叶子 -->
        <path d="M18 40C22 38 26 38 28 40C26 38 22 36 18 38Z" fill="#aaa" opacity="0.8"/>
        <path d="M16 32C20 30 24 30 26 32C24 30 20 28 16 30Z" fill="#aaa" opacity="0.8"/>
        <path d="M14 24C18 22 22 22 24 24C22 22 18 20 14 22Z" fill="#aaa" opacity="0.8"/>
        <path d="M13 16C16 14 20 14 22 16C20 14 16 12 13 14Z" fill="#aaa" opacity="0.8"/>
        <path d="M14 8C17 6 20 6 22 8C20 6 17 5 14 7Z" fill="#aaa" opacity="0.8"/>
      </svg>
      <span class="title-text">VIP奖励列表</span>
      <svg class="title-deco title-deco-right" viewBox="0 0 30 50" fill="none">
        <!-- 主枝干 -->
        <path d="M8 48C12 40 18 30 22 18C24 12 24 6 22 2" stroke="#bbb" stroke-width="1.2" fill="none" opacity="0.8"/>
        <!-- 右侧叶子 -->
        <path d="M16 36C20 34 24 34 26 36C24 34 20 32 16 34Z" fill="#aaa" opacity="0.8"/>
        <path d="M20 28C24 26 27 26 29 28C27 26 24 24 20 26Z" fill="#aaa" opacity="0.8"/>
        <path d="M22 20C25 18 28 18 30 20C28 18 25 16 22 18Z" fill="#aaa" opacity="0.8"/>
        <path d="M21 12C24 10 26 10 28 12C26 10 24 8 21 10Z" fill="#aaa" opacity="0.8"/>
        <path d="M18 6C20 4 22 4 24 6C22 4 20 3 18 5Z" fill="#aaa" opacity="0.8"/>
        <!-- 左侧叶子 -->
        <path d="M12 40C8 38 4 38 2 40C4 38 8 36 12 38Z" fill="#aaa" opacity="0.8"/>
        <path d="M14 32C10 30 6 30 4 32C6 30 10 28 14 30Z" fill="#aaa" opacity="0.8"/>
        <path d="M16 24C12 22 8 22 6 24C8 22 12 20 16 22Z" fill="#aaa" opacity="0.8"/>
        <path d="M17 16C14 14 10 14 8 16C10 14 14 12 17 14Z" fill="#aaa" opacity="0.8"/>
        <path d="M16 8C13 6 10 6 8 8C10 6 13 5 16 7Z" fill="#aaa" opacity="0.8"/>
      </svg>
    </div>

    <!-- 选项卡 -->
    <div class="vip-tabs">
      <div class="vip-tab" :class="{ active: vipTab === 0 }" @click="vipTab = 0">VIP奖励</div>
      <div class="vip-tab" :class="{ active: vipTab === 1 }" @click="vipTab = 1">规则说明</div>
    </div>

    <!-- VIP奖励列表 -->
    <div class="vip-reward-list" v-if="vipTab === 0">
      <div class="vip-list-header">
        <span class="header-level">等级</span>
        <span class="header-reward">奖励/特权</span>
        <span class="header-action"></span>
      </div>
      <div class="vip-list-item" v-for="item in vipList" :key="item.level">
        <div class="vip-item-row" @click="toggleExpand(item.level)">
          <div class="vip-item-level">
            <div class="vip-item-icon-wrap">
              <div class="vip-item-icon-bg"></div>
              <img :src="getVipIcon(item.level)" class="vip-item-icon" />
            </div>
            <span class="vip-item-label">VIP {{ item.level }}</span>
          </div>
          <div class="vip-item-reward">
            <span class="reward-label">总奖金 </span>
            <span class="reward-amount">{{ item.totalBonus }}</span>
          </div>
          <div class="vip-item-action">
            <span class="action-text">{{ item.expanded ? '收起' : '展开' }}</span>
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" :style="{ transform: item.expanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }">
              <path d="M6 9L12 15L18 9" stroke="#DFB372" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
        <!-- 展开内容 -->
        <div class="vip-item-detail" v-if="item.expanded">
          <!-- VIP 0 特殊内容 -->
          <template v-if="item.level === 0">
            <div class="detail-section">
              <div class="detail-row">
                <span class="detail-label">最低可获得奖金</span>
                <span class="detail-value">0.00</span>
              </div>
            </div>
            <div class="detail-section">
              <div class="detail-row">
                <div class="detail-icon-wrap">
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="none">
                    <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#DFB372"/>
                  </svg>
                </div>
                <div class="detail-content">
                  <div class="detail-title">VIP特权</div>
                  <div class="detail-privileges">
                    <div class="privilege-row">
                      <span>日提现总额 <strong>不限制</strong></span>
                      <span>日提现次数 <strong>不限制</strong></span>
                    </div>
                    <div class="privilege-row">
                      <span>日免手续费笔数 <strong>0笔</strong></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <!-- VIP 1+ 内容 -->
          <template v-else>
            <div class="detail-section">
              <div class="detail-row">
                <span class="detail-label">升级VIP{{ item.level }}可获得奖金</span>
                <span class="detail-value gold">{{ item.upgradeBonus }}</span>
                <div class="detail-action-btn recharge-btn" @click="handleRecharge">去充值</div>
              </div>
            </div>
            <div class="detail-section">
              <div class="salary-row">
                <div class="salary-icon-wrap">
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="none">
                    <rect x="3" y="4" width="18" height="18" rx="2" fill="#4A90D9"/>
                    <text x="12" y="16" text-anchor="middle" fill="#fff" font-size="10" font-weight="bold">01</text>
                  </svg>
                </div>
                <div class="salary-content">
                  <div class="salary-title">日工资 <span class="salary-bonus">+{{ item.dailySalary }}</span></div>
                  <div class="salary-desc">每日充值{{ formatNumber(item.dailyRecharge) }}，投注{{ formatNumber(item.dailyBet) }}</div>
                </div>
                <div class="salary-btn" @click="handleGoGame">去游戏</div>
              </div>
            </div>
            <div class="detail-section">
              <div class="salary-row">
                <div class="salary-icon-wrap">
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="none">
                    <rect x="3" y="4" width="18" height="18" rx="2" fill="#4CAF50"/>
                    <text x="12" y="16" text-anchor="middle" fill="#fff" font-size="10" font-weight="bold">07</text>
                  </svg>
                </div>
                <div class="salary-content">
                  <div class="salary-title">周工资 <span class="salary-bonus">+{{ item.weeklySalary }}</span></div>
                  <div class="salary-desc">每周投注{{ formatNumber(item.weeklyBet) }}</div>
                </div>
                <div class="salary-btn" @click="handleGoGame">去游戏</div>
              </div>
            </div>
            <div class="detail-section">
              <div class="salary-row">
                <div class="salary-icon-wrap">
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="none">
                    <rect x="3" y="4" width="18" height="18" rx="2" fill="#2196F3"/>
                    <text x="12" y="16" text-anchor="middle" fill="#fff" font-size="10" font-weight="bold">30</text>
                  </svg>
                </div>
                <div class="salary-content">
                  <div class="salary-title">月工资 <span class="salary-bonus">+{{ item.monthlySalary }}</span></div>
                  <div class="salary-desc">每月投注{{ formatNumber(item.monthlyBet) }}</div>
                </div>
                <div class="salary-btn" @click="handleGoGame">去游戏</div>
              </div>
            </div>
            <div class="detail-section">
              <div class="salary-row">
                <div class="salary-icon-wrap">
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="none">
                    <circle cx="12" cy="12" r="10" fill="#FF6B35"/>
                    <path d="M8 12L11 15L16 9" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <div class="salary-content">
                  <div class="salary-title">晋级奖金 <span class="salary-bonus">+{{ item.promotionBonus }}</span></div>
                  <div class="salary-desc">晋级再投注{{ formatNumber(item.promotionBet) }}</div>
                </div>
                <div class="salary-btn" @click="handleGoGame">去游戏</div>
              </div>
            </div>
            <div class="detail-section">
              <div class="detail-row">
                <div class="detail-icon-wrap">
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="none">
                    <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#DFB372"/>
                  </svg>
                </div>
                <div class="detail-content">
                  <div class="detail-title">VIP特权</div>
                  <div class="detail-privileges">
                    <div class="privilege-row">
                      <span>日提现总额 <strong>不限制</strong></span>
                      <span>日提现次数 <strong>不限制</strong></span>
                    </div>
                    <div class="privilege-row">
                      <span>日免手续费笔数 <strong>0笔</strong></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- 规则说明 -->
    <div class="vip-rules" v-if="vipTab === 1">
      <div class="rule-item" v-for="(rule, index) in rules" :key="index">
        <span class="rule-num">{{ index + 1 }}.</span>
        <span class="rule-text" v-html="rule"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'vipPage',
  data() {
    return {
      currentLevel: 0,
      progressPercent: 0,
      nextLevelAmount: 2000,
      vipTab: 0,
      vipList: [],
      rules: [
        '<strong>晋级标准：</strong>满足VIP晋级要求（即充值或有效投注都满足条件），即可晋级相应VIP等级，获得相应晋级奖金，如连续晋级多级，可获得全部等级晋级奖金，今日00:00:00以后才可领取；',
        '<strong>日工资：</strong>每日充值及有效投注满足当前等级日工资要求，可获得对应日工资，如连续晋级多级，仅可获得当前等级日工资，次日00:00:00以后才可领取，2天后未领取，奖励过期；',
        '<strong>周工资：</strong>每周充值及有效投注满足当前等级周工资要求，可获得对应周工资，如连续晋级多级，仅可获得当前等级周工资，下周一00:00:00以后才可领取，3天后未领取，奖励过期；',
        '<strong>月工资：</strong>每月充值及有效投注满足当前等级月工资要求，可获得对应月工资，如连续晋级多级，仅可获得当前等级月工资，下月1日00:00:00以后才可领取，7天后未领取，奖励过期；',
        '<strong>生日礼金：</strong>生日当天可领取对应等级的生日礼金，当天未领取，奖励过期；',
        '<strong>奖励过期说明：</strong>奖励过期直接作废，请在领取倒计时结束前进行领取；',
        '<strong>稽核说明：</strong>VIP所赠送的奖金需1倍流水（即稽核或有效投注）才能提现，投注打码不限游戏平台；',
        '<strong>活动声明：</strong>本功能仅限账号本人进行正常游戏投注，禁止租借账号、无风险投注(对赌、对刷、低赔抽水)、恶意套利、使用外挂式、机器人、利用协议、漏洞、接口、群控或其他技术手段参与，一经查核属实，本平台有权终止会员登录、暂停会员使用网站、及没收奖金和不当盈利的权利，无需特别通知；',
        '<strong>解释说明：</strong>会员领取VIP奖励时，本平台将默认会员同意且遵守对奖条件等相关规定。为避免文字理解歧义，本平台保留该活动最终解释权。',
      ],
    };
  },
  created() {
    this.initVipList();
  },
  methods: {
    initVipList() {
      const vipData = [
        { level: 0, totalBonus: '0.00', upgradeBonus: '0.00', dailySalary: '0.00', weeklySalary: '0.00', monthlySalary: '0.00', promotionBonus: '0.00', dailyRecharge: 0, dailyBet: 0, weeklyBet: 0, monthlyBet: 0, promotionBet: 0 },
        { level: 1, totalBonus: '15.38', upgradeBonus: '15.38', dailySalary: '1.38', weeklySalary: '1.00', monthlySalary: '3.00', promotionBonus: '10.00', dailyRecharge: 200, dailyBet: 1500, weeklyBet: 100, monthlyBet: 100, promotionBet: 2000 },
        { level: 2, totalBonus: '28.38', upgradeBonus: '13.00', dailySalary: '2.00', weeklySalary: '2.00', monthlySalary: '5.00', promotionBonus: '15.00', dailyRecharge: 500, dailyBet: 3000, weeklyBet: 200, monthlyBet: 200, promotionBet: 5000 },
        { level: 3, totalBonus: '64.88', upgradeBonus: '36.50', dailySalary: '3.00', weeklySalary: '3.00', monthlySalary: '8.00', promotionBonus: '25.00', dailyRecharge: 1000, dailyBet: 5000, weeklyBet: 500, monthlyBet: 500, promotionBet: 10000 },
        { level: 4, totalBonus: '136.88', upgradeBonus: '72.00', dailySalary: '5.00', weeklySalary: '5.00', monthlySalary: '15.00', promotionBonus: '50.00', dailyRecharge: 2000, dailyBet: 10000, weeklyBet: 1000, monthlyBet: 1000, promotionBet: 20000 },
        { level: 5, totalBonus: '261.88', upgradeBonus: '125.00', dailySalary: '8.00', weeklySalary: '8.00', monthlySalary: '25.00', promotionBonus: '80.00', dailyRecharge: 5000, dailyBet: 20000, weeklyBet: 2000, monthlyBet: 2000, promotionBet: 50000 },
        { level: 6, totalBonus: '533.88', upgradeBonus: '272.00', dailySalary: '12.00', weeklySalary: '12.00', monthlySalary: '40.00', promotionBonus: '150.00', dailyRecharge: 10000, dailyBet: 50000, weeklyBet: 5000, monthlyBet: 5000, promotionBet: 100000 },
        { level: 7, totalBonus: '833.88', upgradeBonus: '300.00', dailySalary: '15.00', weeklySalary: '15.00', monthlySalary: '50.00', promotionBonus: '200.00', dailyRecharge: 20000, dailyBet: 100000, weeklyBet: 10000, monthlyBet: 10000, promotionBet: 200000 },
        { level: 8, totalBonus: '1,125.88', upgradeBonus: '292.00', dailySalary: '20.00', weeklySalary: '20.00', monthlySalary: '60.00', promotionBonus: '250.00', dailyRecharge: 30000, dailyBet: 150000, weeklyBet: 15000, monthlyBet: 15000, promotionBet: 300000 },
      ];

      // 生成50个VIP等级
      this.vipList = [];
      for (let i = 0; i < 50; i++) {
        if (i < vipData.length) {
          this.vipList.push({ ...vipData[i], expanded: false });
        } else {
          // VIP9-VIP49 使用VIP1的数据模式递增
          const base = vipData[1];
          const multiplier = Math.pow(1.5, i - 1);
          this.vipList.push({
            level: i,
            totalBonus: this.calcBonus(i),
            upgradeBonus: this.calcUpgrade(i),
            dailySalary: this.formatNum(base.dailySalary * multiplier),
            weeklySalary: this.formatNum(base.weeklySalary * multiplier),
            monthlySalary: this.formatNum(base.monthlySalary * multiplier),
            promotionBonus: this.formatNum(base.promotionBonus * multiplier),
            dailyRecharge: Math.round(base.dailyRecharge * multiplier),
            dailyBet: Math.round(base.dailyBet * multiplier),
            weeklyBet: Math.round(base.weeklyBet * multiplier),
            monthlyBet: Math.round(base.monthlyBet * multiplier),
            promotionBet: Math.round(base.promotionBet * multiplier),
            expanded: false,
          });
        }
      }
    },
    calcBonus(level) {
      if (level === 0) return '0.00';
      const base = 15.38;
      const val = base * Math.pow(1.8, level - 1);
      return val >= 1000 ? val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : val.toFixed(2);
    },
    calcUpgrade(level) {
      if (level === 0) return '0.00';
      const base = 15.38;
      const val = base * Math.pow(1.8, level - 1) * 0.6;
      return val >= 1000 ? val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : val.toFixed(2);
    },
    formatNum(val) {
      return val >= 1000 ? val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : val.toFixed(2);
    },
    formatNumber(num) {
      if (num >= 10000) {
        return num.toLocaleString('en-US');
      }
      return num.toString();
    },
    getVipIcon(level) {
      return '/static/image/vip/style_4_vip_style0.avif';
    },
    toggleExpand(level) {
      const item = this.vipList.find(v => v.level === level);
      if (item) {
        item.expanded = !item.expanded;
      }
    },
    handleUpgrade() {
      this.$router.push('/deposit');
    },
    handleRecharge() {
      this.$router.push('/deposit');
    },
    handleGoGame() {
      this.$router.push('/game');
    },
  },
};
</script>

<style lang="scss" scoped>
.vip-page {
  padding-bottom: 1rem;
}

// 顶部VIP卡片
.vip-card {
  position: relative;
  margin: 0.15rem;
  border-radius: 0.15rem;
  overflow: hidden;
  min-height: 2.6rem;

  .vip-card-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    .vip-card-bg-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .vip-card-content {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0 0.3rem 0.3rem;
    z-index: 1;
  }

  .vip-card-left {
    flex: 1;

    .vip-current-label {
      display: inline-block;
      background: #d0d0d0;
      color: #5a7faa;
      font-size: 0.3rem;
      padding: 0.2rem 0.2rem 0.1rem 0.2rem;
      border-radius: 0.15rem 0 0.15rem 0;
      margin-bottom: 0.04rem;
      margin-left: -0.3rem;
      margin-top: -0.12rem;
    }

    .vip-level-row {
      display: flex;
      align-items: baseline;
      gap: 0.15rem;
      margin-bottom: 0.06rem;

      .vip-level-text {
        font-size: 0.55rem;
        font-weight: bold;
        color: #1a3a6b;
        font-style: italic;
        letter-spacing: 0.02rem;
      }

      .vip-upgrade-btn {
        color: #5a7faa;
        font-size: 0.24rem;
        background: #fff;
        padding: 0.04rem 0.15rem;
        border-radius: 0.1rem;
      }
    }

    .vip-progress-row {
      display: flex;
      align-items: center;
      gap: 0.1rem;
      margin-bottom: 0.08rem;

      .vip-progress-pct {
        display: inline-block;
        background: #1a3a6b;
        color: #fff;
        font-size: 0.22rem;
        font-weight: bold;
        padding: 0.02rem 0.08rem;
        border-radius: 0.1rem;
        margin-right: 0.05rem;
      }

      .vip-progress-bar {
        flex: 1;
        max-width: 2rem;
        height: 0.22rem;
        background: #c8c9cc;
        border-radius: 0.05rem;
        position: relative;
        overflow: visible;

        .vip-progress-fill {
          height: 100%;
          background: linear-gradient(90deg, #4FC3F7, #29B6F6);
          border-radius: 0.05rem;
          min-width: 0.1rem;
        }

        .vip-progress-thumb {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 0.18rem;
          height: 0.18rem;
          background: #fff;
          border-radius: 50%;
          box-shadow: 0 0 0.04rem rgba(0, 0, 0, 0.3);
        }
      }

      .vip-level-next {
        font-size: 0.32rem;
        color: #1a3a6b;
        font-weight: bold;
        font-style: italic;
        margin-left: 0.1rem;
      }
    }

    .vip-tip-text {
      font-size: 0.3rem;
      color: #7a8fa6;
      font-weight: 600;
      margin-top: 0.2rem;
    }
  }

  .vip-card-right {
    flex-shrink: 0;
    display: flex;
    align-items: center;

    .vip-icon-wrap {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;

      .vip-card-icon {
        width: 2.5rem;
        height: 2.5rem;
        position: relative;
        z-index: 1;
      }

      .vip-icon-bg {
        position: absolute;
        top: 0.58rem;
        left: 50%;
        transform: translateX(-50%);
        width: 1.2rem;
        height: 1.2rem;
        background: #0cdec3;
        clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
        z-index: 0;
      }

      .vip-icon-badge-num {
        position: absolute;
        bottom: 0.6rem;
        left: 50%;
        transform: translateX(-50%);
        color: #fff;
        font-size: 0.28rem;
        font-weight: bold;
        text-shadow: 0 0.01rem 0.02rem rgba(0, 0, 0, 0.3);
        z-index: 2;
      }
    }
  }
}

// VIP奖励列表标题
.vip-list-title {
  text-align: center;
  padding: 0.35rem 0 0.2rem;
  font-size: 0.45rem !important;
  color: #fff;
  font-weight: bold;

  .title-deco {
    width: 0.45rem;
    height: 0.75rem;
    vertical-align: middle;
    margin: 0 0.1rem;
  }

  .title-text {
    font-size: 0.45rem !important;
    font-style: italic;
  }
}

// 选项卡
.vip-tabs {
  display: flex;
  padding: 0.15rem 0;

  .vip-tab {
    flex: 1;
    text-align: center;
    font-size: 0.35rem;
    color: #fff;
    padding: 0.08rem 0 0.25rem;
    font-weight: 600;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 2px;
      background: transparent;
      transition: width 0.3s;
    }

    &.active {
      color: #DFB372;

      &::after {
        width: 2rem;
        background: #DFB372;
      }
    }
  }
}

// VIP奖励列表
.vip-reward-list {
  margin: 0.15rem 0.15rem 0;

  .vip-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.12rem 0.15rem;
    font-size: 0.3rem;
    color: #fff;
    border-bottom: 1px solid #333;

    .header-level {
      width: 25%;
    }

    .header-reward {
      flex: 1;
    }

    .header-action {
      width: 20%;
      text-align: right;
    }
  }

  .vip-list-item {
    border-bottom: 1px solid #333;

    .vip-item-row {
      display: flex;
      align-items: center;
      padding: 0.15rem;
      cursor: pointer;
    }

    .vip-item-level {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 0.04rem;
      width: 25%;

      .vip-item-icon-wrap {
        position: relative;
        width: 1.5rem;
        height: 1.5rem;
        margin-left: -0.3rem;
      }

      .vip-item-icon-bg {
        position: absolute;
        top: 0.28rem;
        left: 50%;
        transform: translateX(-50%);
        width: 0.8rem;
        height: 0.8rem;
        background: #09a775;
        clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
        z-index: 0;
      }

      .vip-item-icon {
        width: 1.5rem;
        height: 1.5rem;
        position: relative;
        z-index: 1;
      }

      .vip-item-label {
        font-size: 0.35rem;
        color: #fff;
        font-weight: 600;
      }
    }

    .vip-item-reward {
      flex: 1;

      .reward-label {
        font-size: 0.3rem;
        color: #fff;
      }

      .reward-amount {
        font-size: 0.35rem;
        color: #DFB372;
        font-weight: bold;
      }
    }

    .vip-item-action {
      display: flex;
      align-items: center;
      gap: 0.04rem;
      width: 20%;
      justify-content: flex-end;

      .action-text {
        font-size: 0.3rem;
        color: #DFB372;
      }
    }

    .vip-item-detail {
      padding: 0 0.15rem 0.15rem;
      background: #1a1a1a;

      .detail-section {
        margin-bottom: 0.12rem;
      }

      .detail-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.1rem 0;

        .detail-label {
          font-size: 0.3rem;
          color: #ccc;
        }

        .detail-value {
          font-size: 0.35rem;
          color: #fff;
          font-weight: bold;

          &.gold {
            color: #DFB372;
          }
        }

        .detail-action-btn {
          padding: 0.1rem 0.3rem;
          border-radius: 0.3rem;
          font-size: 0.3rem;
          color: #fff;
        }

        .recharge-btn {
          background: #ffaa09;
          color: #fff;
        }
      }

      .detail-icon-wrap {
        flex-shrink: 0;
        margin-right: 0.1rem;
      }

      .detail-content {
        flex: 1;

        .detail-title {
          font-size: 0.35rem;
          color: #fff;
          font-weight: 600;
          margin-bottom: 0.06rem;
        }

        .detail-privileges {
          .privilege-row {
            display: flex;
            gap: 0.3rem;
            margin-bottom: 0.04rem;
            font-size: 0.3rem;
            color: #999;

            strong {
              color: #DFB372;
              font-weight: 600;
            }
          }
        }
      }

      .salary-row {
        display: flex;
        align-items: center;
        padding: 0.1rem 0;
        border-bottom: 1px solid #333;

        &:last-child {
          border-bottom: none;
        }

        .salary-icon-wrap {
          flex-shrink: 0;
          margin-right: 0.1rem;
        }

        .salary-content {
          flex: 1;

          .salary-title {
            font-size: 0.35rem;
            color: #fff;
            font-weight: 600;

            .salary-bonus {
              color: #DFB372;
              font-weight: bold;
            }
          }

          .salary-desc {
            font-size: 0.3rem;
            color: #999;
            margin-top: 0.02rem;
          }
        }

        .salary-btn {
          background: linear-gradient(180deg, #fbddb2 0%, #f2cc95 50%, #dfb372 100%) !important;
          color: #000;
          font-size: 0.3rem;
          padding: 0.1rem 0.3rem;
          border-radius: 0.3rem;
          flex-shrink: 0;
        }
      }
    }
  }
}

// 规则说明
.vip-rules {
  margin: 0 0.15rem;
  padding: 0.15rem;
  background: #1a1a1a;
  border-radius: 0.1rem;

  .rule-item {
    margin-bottom: 0.15rem;
    font-size: 0.3rem;
    color: #ccc;
    line-height: 1.6;

    .rule-num {
      color: #DFB372;
      font-weight: 600;
      font-size: 0.35rem;
    }

    .rule-text {
      strong {
        color: #fff;
      }
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/component/vipPage.vue